/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/molecules/avatar/css/avatar';
import './page-intro.scss';
import './modifier/author.scss';
import './modifier/video.scss';
